import { render } from "./cart.vue?vue&type=template&id=4cca8c34&scoped=true&lang=html"
import script from "./cart.vue?vue&type=script&lang=js"
export * from "./cart.vue?vue&type=script&lang=js"

import "./cart.vue?vue&type=style&index=0&id=4cca8c34&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cca8c34"]])

export default __exports__